import { render, staticRenderFns } from "./BaseInput.vue?vue&type=template&id=a1dcdec2&scoped=true&"
import script from "./BaseInput.vue?vue&type=script&lang=js&"
export * from "./BaseInput.vue?vue&type=script&lang=js&"
import style0 from "./BaseInput.vue?vue&type=style&index=0&id=a1dcdec2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1dcdec2",
  null
  
)

export default component.exports